$(document).ready(function(){
  $('.plan_selector').on('change',function(){
      $(this).parent().addClass('active').siblings().removeClass('active');
       var id = $(this).val();
       var subs = $('.select-delivery-time option:selected').val();
       var price =  parseInt($(".variant_selector option:selected").data('price')) * 0.01;
       var discount = parseInt($(".variant_selector option:selected").data('discount')) * 0.01;
       var compare = parseInt($(".variant_selector option:selected").data('compare')) * 0.01;

        
       if(id == 1) {
          $('.discount-wrap').show();
          $('#selling_plan').val(subs);
          $(".reg_cost_amount").text($('.subs_price_amount').text());
          if(price > discount) {
            $('.product-discount-price').show();
            let ot = $('.onetime_price_amount').text();
            // console.log('reg price ' + ot);
            $('.value_price_amount').text(ot);
          }else{
            $('.product-discount-price').hide();
          }
          $('.subscribe-text').addClass('show').removeClass('hide');
          $('.onetime-text').removeClass('show').addClass('hide');
        }else{
          $('.discount-wrap').hide();
          $('#selling_plan').val('');
          if(compare > price) {
            $('.product-discount-price').show();
          }else{
            $('.product-discount-price').hide();
          }
          $(".reg_cost_amount").text($('.onetime_price_amount').text());
          $('.subscribe-text').addClass('hide').removeClass('show');
          $('.onetime-text').removeClass('hide').addClass('show');
        }

        
    })
});

$(document).ready(function () {
    
  $(".bundlAddToCart").click(function (event) {
    // ✅ Check terms checkbox
    if (!$("#terms").is(":checked")) {
      alert("Please agree to the terms and conditions before continuing.");
      return false; // stop further execution
    }
    
    let withMainProduct = parseFloat($("#with_main_product").val()); 

    event.preventDefault(); // Prevent default form submission

    let plan = $("input[name='plan']:checked").val(); // Get plan selection (1 = Subscription)
    let items = []; // Array to store products


    if(withMainProduct == 1) {
      let mainProductId = $('#product_id').val(); 
      let mainSubs = $(".select-delivery-time option:selected").val(); 
      let mainQty = $(".bundle_selector:first").val(); 
  
      // Add main product
      let mainProduct = { id: mainProductId, quantity: mainQty };
      if (plan == 1) {
        mainProduct.selling_plan = mainSubs; // Apply subscription if selected
      }


      items.push(mainProduct);
    }
   

    // Loop through all bundle selectors
    let firstSkipped = false; 
    $(".bundle_selector").each(function (index) {

      if (!firstSkipped && withMainProduct == 1) {
          firstSkipped = true; // Skip the first iteration
          return true; // `true` continues to the next loop iteration
      }

      let bundleProductId = $(this).data("id"); // Get bundle product ID
      let bundleQuantity = parseInt($(this).val(), 10); // Get selected quantity
      if (bundleQuantity > 0) {
        let bundleSubs = $(this).closest('.choose-single-product-flaver-item').find('.bundle-delivery-time option:selected').val(); // Get bundle subscription

        let bundleItem = { id: bundleProductId, quantity: bundleQuantity };
        if (plan == 1) {
          bundleItem.selling_plan = bundleSubs; // Apply subscription if selected
        }

        items.push(bundleItem); // Add bundle product
        
      }
    });

    // Send AJAX request to Shopify cart
    
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: { items: items }, // Shopify auto-formats the request
      dataType: "json",
      success: function () {
        console.log("Added to cart successfully!");
        // window.location.href = "/cart"; // Redirect to cart
      },
      error: function (error) {
        console.error("Error:", error);
      },
    });
  });
});


  // update price 
  

  $(document).ready(function () {
    let withMainProduct = parseFloat($("#with_main_product").val()); 
    function updateTotalPrice() {
      let totalPrice;
      let totalDiscount;
      let totalCompare;
      let totalQty;
      let save;

      if(withMainProduct == 1){
        // let mainPrice = parseFloat($(".bundle_selector:first").attr('data-price')); 
        // let mainDiscount = parseFloat($(".bundle_selector:first").attr('data-discount')); 
        // let mainCompare = parseFloat($(".bundle_selector:first").attr('data-compare')); 
        // let mainQty = parseFloat($(".bundle_selector:first").val());

        let mainPrice = parseFloat($('.variant_selector option:selected').attr('data-price')) * 0.01; 
        let mainDiscount = parseFloat($(".variant_selector option:selected").attr('data-price')) * 0.01; 
        let mainCompare = parseFloat($(".variant_selector option:selected").attr('data-compare')) * 0.01; 
        let mainQty = parseFloat($(".bundle_selector:first").val()); 

        totalPrice = mainQty * mainPrice; 
        totalDiscount =  mainQty * mainDiscount; 
        totalCompare = mainQty *  mainCompare; 
        totalQty = mainQty; 

      }else{
        totalPrice = 0; 
        totalDiscount = 0; 
        totalCompare = 0; 
        totalQty = 0; 
      }

      // Loop through all bundle selectors

      let firstSkipped = false; // Flag to track the first iteration
      $(".bundle_selector").each(function (index) {

        if (!firstSkipped && withMainProduct == 1) {
            firstSkipped = true; // Skip the first iteration
            return true; // `true` continues to the next loop iteration
        }

        let bundlePrice = parseFloat($(this).data("price")); 
        let bundleCompare = parseFloat($(this).data("compare")); 
        let bundleDiscount = parseFloat($(this).data("discount")); 
        
        let bundleQuantity = parseInt($(this).val(), 10); 

        if (bundleQuantity > 0) {
          totalPrice += bundlePrice * bundleQuantity; 
          totalDiscount += bundleDiscount * bundleQuantity; 

          if(bundleCompare > 0 ){
            totalCompare += bundleCompare * bundleQuantity; 
          
          }else{
            totalCompare += bundlePrice * bundleQuantity; 
          
          }
          
          totalQty += bundleQuantity; 
        }
      
      });
      
    
      priceUpdateInfo(totalPrice, totalDiscount, totalCompare, save, totalQty);
      
    }

    // Event Listeners
    $(".bundle_selector, input[name='purchase_type']").change(updateTotalPrice);

    // Initial calculation on page load
    if(withMainProduct == 1){
      updateTotalPrice();
    }
    

    
    $("#select_delivery_time").change(function () {
      let selectedIndex = $(this).prop("selectedIndex"); // Get the selected option index

      // Set all bundle subscriptions to the same index as the main subscription
      $(".bundle-delivery-time").each(function () {
        $(this).prop("selectedIndex", selectedIndex);
      });
  
    });

    
 
  });

  function priceUpdateInfo(totalPrice, totalDiscount, totalCompare, save, totalQty, x) {
      let discount = $('#discount').val();
      let discount_2 = $('#discount_2').val();
      let discount_3 = $('#discount_3').val();

      discount = (100 - discount) / 100;
      discount_2 = (100 - discount_2) / 100;
      discount_3 = (100 - discount_3) / 100;

      let save2;
      let save3;

      if (totalQty == 1) {
          save2 = (totalPrice * 2) - ((totalDiscount * 2) * discount_2);
          $('.step-2 .step-discount em').text(currency + save2.toFixed());

          save3 = (totalPrice * 3) - ((totalDiscount * 3) * discount_3);
          $('.step-3 .step-discount em').text(currency + save3.toFixed());
      }

      const updatePrice = parseInt($(".variant_selector option:selected").data('price')) * 0.01;
      const updateQty = $('.bundle_selector option:selected').val();

      const saveAmount_2 = ((updatePrice - (discount_2 * updatePrice)) * updateQty).toFixed(0);
      const saveAmount_3 = ((updatePrice - (discount_3 * updatePrice)) * updateQty).toFixed(0);

      // let x = opt;
      // console.log('totalPrice ' + totalPrice);

      if(totalQty == 1) {
        totalPrice = totalPrice;
        totalDiscount = totalDiscount * discount;
      } else if(totalQty == 2) {
        totalPrice = totalPrice;
        totalDiscount = totalDiscount * discount_2;
        
      } else if(totalQty >= 3) {
        totalPrice = totalPrice;
        totalDiscount = totalDiscount * discount_3;
       
      }else{
        totalPrice = totalPrice;
        totalDiscount = totalDiscount;
        
      }

      if(totalCompare > totalPrice ) {
        save = totalCompare - totalDiscount;
        save3 = totalCompare - totalDiscount;
      }else{
        save = totalPrice - totalDiscount;
        save3 = totalPrice - totalDiscount;
      }
     
      let progress = 0;
      let discountAmount1 = parseInt($('#discount_amount').data('discount1'));
      let discountAmount2 = parseInt($('#discount_amount').data('discount2'));
      let discountText = $('#discount_text').data('discountext');
      let discountText2 = $('#discount_amount').data('discountext2');
      let message = $('#message').val();
      let message_2 = $('#message').data('message');

      totalPrice = parseInt(totalPrice);
      totalCompare = parseInt(totalCompare);

      // $('#final_price').attr('data-price', totalPrice.toFixed(2))
      // .attr('data-discount', totalDiscount.toFixed(2))
      // .attr('data-compare', totalCompare.toFixed(2));

      // if(x==1) {
      //   $('.bundle_selector').attr('data-price', totalPrice.toFixed(2))
      //   .attr('data-discount', totalDiscount.toFixed(2))
      //   .attr('data-compare', totalCompare.toFixed(2));
      //   // alert('1')
      // }

      if (totalQty == 1) {
          $('.discont-text').text('You’re 1 item away from an additional discount');
          $('.step-1 .step-discount em').text(currency + save.toFixed());
          progress = 33;
      } else if (totalQty == 2) {
          $('.discont-text').html(message);
          $('.discont-text em').text(currency + saveAmount_2);
          
          // $('.discont-text').html( 'You get' + currency + discountAmount2 +' off ' + message);
          
          progress = 66;
      } else if (totalQty >= 3) {
        $('.discont-text').html(message_2)
        if(x != 1) {
          $('.discont-text em').text(currency + saveAmount_3)
        }else{
          let latesPrice = parseInt($(".variant_selector option:selected").data('price')) * 0.01;
          const latestQty = $('.bundle_selector option:selected').val();
          const latestAmount_3 = ((latesPrice - (discount_3 * latesPrice)) * latestQty).toFixed(0);
          $('.discont-text em').text(currency + latestAmount_3)
        }
        // $('.discont-text').text('Add one more, for free!') 
        
          progress = 100;  
      } 
      // console.log('test ' + saveAmount_3);
      
      
      // else if (totalQty >= 4) {
      //     $('.discont-text').text(message_2)
      //     progress = 100;
      // }

      $(".progress .progress_bar").css("width", progress + "%");

      $(".subs_price_amount").text(currency + totalDiscount.toFixed(2));
      $(".onetime_price_amount").text(currency + totalPrice.toFixed(2));

      // console.log('totalDiscount ' + totalDiscount);
      // console.log('totalPrice ' + totalPrice);
      // console.log('totalCompare ' + totalCompare);

      if(totalPrice == totalDiscount ) {
        $(".product-discount-price").hide();
      }else{
        $(".product-discount-price").show();
        if(totalCompare > totalPrice) {
          $(".value_price_amount").text(currency + parseFloat(totalCompare).toFixed(2));
        }else{
          $(".value_price_amount").text(currency + parseFloat(totalPrice).toFixed(2));
        }
        
      }

      // console.log('Hello 1234')
    
      // console.log('save ' + save);

      if(save > 0) {
        $(".fixed_discount_amount").show().text('Save ' + currency + save.toFixed());
      }else{
        $(".fixed_discount_amount").hide()
      }

      
      

      // alert('test ' + totalDiscount.toFixed(2));

      // If subscription is selected, apply the discount
      if ($(".plan_selector:checked").val() == 1) {
        $(".reg_cost_amount").text(currency + totalDiscount.toFixed(2));
      }else{
        $(".reg_cost_amount").text(currency + totalPrice.toFixed(2));
      }
      // console.log('test 123' )
      if(totalQty == 0) {
        $('.add-to-cart-btn-area').addClass('disable');
      }else{
        $('.add-to-cart-btn-area').removeClass('disable');
      }
    }

  // image change 


$(document).ready(function () {
    var swiperThumb;
    var swiperFeatured;

    function initializeSwipers() {
        swiperThumb = new Swiper(".single-product-thumb", {
            loop: true,
            spaceBetween: 6,
            slidesPerView: 6,
            freeMode: true,
            watchSlidesProgress: true,
        });

        swiperFeatured = new Swiper(".single-product-featured", {
            loop: true,
            spaceBetween: 10,
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            },
           
            thumbs: {
                swiper: swiperThumb,
            },
        });
    }

    // Initialize Swipers on page load
    initializeSwipers();

    $(".flaver-item-card").on("click", function () {
        let productHandle = $(this).next().find(".bundle_selector").data("handle");

        if (!productHandle) {
            console.error("Product handle not found!");
            return;
        }

        // Fetch product data
        $.getJSON(`/products/${productHandle}.json`, function (data) {
            let media = data.product.images;
            let $sliderWrapper = $(".single-product-featured .swiper-wrapper");
            let $thumbWrapper = $(".single-product-thumb .swiper-wrapper");

            if (!$sliderWrapper.length || !$thumbWrapper.length) return;

            // Destroy existing Swipers before updating the images
            if (swiperFeatured) swiperFeatured.destroy(true, true);
            if (swiperThumb) swiperThumb.destroy(true, true);

            // Clear existing slides
            $sliderWrapper.empty();
            $thumbWrapper.empty();

            // Add new images to the slider
            $.each(media, function (index, image) {
                let slide = `<div class="swiper-slide">
                                <img src="${image.src}" class="single-product-img" alt="Bundle Image">
                             </div>`;
                let thumbSlide = `<div class="swiper-slide">
                                    <img src="${image.src}" class="single-thumb-img" alt="Bundle Thumbnail">
                                  </div>`;

                $sliderWrapper.append(slide);
                $thumbWrapper.append(thumbSlide);
            });

            // Reinitialize Swipers
            setTimeout(function () {
                initializeSwipers(); // Reinitialize after updating images
            }, 100);
        }).fail(function () {
            console.error("Failed to load product data!");
        });
    });
});



